import { VariantProps, cva } from 'class-variance-authority';

export const actionButtonStyles = cva(
  'transition-colors ease-out duration-200 fill-primaryMain outline-none flex items-center justify-center bg-primary50 data-[hovered="true"]:bg-primary100 data-[focused="true"]:bg-primary100 data-[pressed="true"]:bg-primary200 data-[disabled="true"]:bg-grayscale50 data-[disabled="true"]:cursor-not-allowed data-[disabled="true"]:fill-grayscale300',
  {
    variants: {
      size: {
        large: 'min-w-32 w-32 h-32 rounded-12',
        small: 'min-w-24 w-24 h-24 rounded-6',
      },
    },
  },
);

export type ActionButtonStylesVariants = VariantProps<
  typeof actionButtonStyles
>;
